// export const BASE_URL = "https://laravel-admin-api.triamiz.in/";
// export const BASE_URL = "http://localhost:8000/";
export const BASE_URL = "PLACEHOLDER_BASE_URL";
export const API_URL = `${BASE_URL}api`;

export const END_POINT = {
  LOGIN: `${API_URL}/login`,
  SIGNUP: `${API_URL}/register`,
  REFRESH_PASSWORD: `${API_URL}/refresh-token`,
  MENUS: `${API_URL}/menus`,
  MODULES: `${API_URL}/modules`,
  FORGOT_PASSWORD: `${API_URL}/forgot-password`,

  // INFO: OTP (request-a-quote verification)
  SEND_OTP: `${API_URL}/send-otp`,
  VERIFY_OTP: `${API_URL}/verify-otp`,

  RESET_PASSWORD: `${API_URL}/profile/edit/password`,
  PROFILE_UPDATE: `${API_URL}/profile/edit`,

  EMAIL_SENT: `${API_URL}/email-sent`,

  // INFO: COMMON API'S
  FILE_UPLOAD: `${API_URL}/upload/file`,
  IMAGE_UPLOAD: `${API_URL}/upload/image-file`,

  // INFO: MANUFACTURES API'S

  MANUFACTURES_LIST: `${API_URL}/manufacturer-list`,
  CATEGORY_LIST: `${API_URL}/category-list`,

  // INFO: INVENTORY API'S

  INVENTORY_ITEMS_LIST: `${API_URL}/inventory/items`,

  // INFO: INVENTORY API'S
  INVENTORY_SEARCH: `${API_URL}/search-inventory`,
  INVENTORY_CATEGORY: `${API_URL}/search-category`,
  INVENTORY_FILTER: `${API_URL}/search-filter`,
  INVENTORY_BOM_UPLOAD: `${API_URL}/bom-upload`,
  INVENTORY_FILTER_COUNT: `${API_URL}/filter-count`,
  INVENTORY_FILTER_RESULT: `${API_URL}/filter-result`,
  INVENTORY_BOM_COLUMN_MAPPING: `${API_URL}/inventory-column-mapping/`,
  INVENTORY_BOM_DETAIL: `${API_URL}/bom-detail/`,
  INVENTORY_EDIT_PART_NUMBER: `${API_URL}/edit-part-number/`,
  INVENTORY_BOM_COLUMN_KEY_SAVE: `${API_URL}/inventory-bom-save-column-key/`,
  INVENTORY_BOM_QUOTE_GENERATE: `${API_URL}/generate-bom-quote`,
  INVENTORY_START_PROCESS: `${API_URL}/start-process`,
  INVENTORY_BOM_STATUS: `${API_URL}/bom-status`,
  BOM_ITEM_REFRESH: `${API_URL}/bom-item-refresh`,

  // INFO: PRODUCTS LIST API'S
  
  PRODUCTS_LIST: `${API_URL}/products/list`,
  PRODUCTS_ACTIVE_PRODUCT: `${API_URL}/products/active-product`,
  PRODUCTS_PRODUCT_BY_SLUG: `${API_URL}/products/product-by-slug`,

  // INFO: CART API'S

  SAVE_CART_ITEMS: `${API_URL}/account/saved-cart/create`,
  DELETE_CART_ITEMS: `${API_URL}/account/saved-cart/delete`,
  LIST_SAVE_CART_ITEMS: `${API_URL}/account/saved-cart/list`,

  GET_ADDRESS: `${API_URL}/account/address`,
  SAVE_ADDRESS: `${API_URL}/account/edit/address`,
  DELETE_ADDRESS: `${API_URL}/account/address/delete`,
  UPDATE_PROFILE: `${API_URL}/account/edit/personal`,

  CREATE_ORDER: `${API_URL}/account/order/create`,
  GET_ORDER: `${API_URL}/account/order/id/`,
  GET_ORDER_LIST: `${API_URL}/account/list/orders`,
  GET_ORDER_DETAILS: `${API_URL}/account/order/details`,

  GET_SITE_SETTINGS: `${API_URL}/settings/site-settings/details`,
  GET_JSON_DETAILS: `${API_URL}/site-settings-json`,
  GET_PAGE_DETAILS: `${API_URL}/page-details`,

  NEWS_LETTER_CREATE: `${API_URL}/news-letter/create`,
  // NEWS_LETTER_LIST: `${API_URL}/news-letter`,

  PROMO_CODE_CHECK: `${API_URL}/promo-code/check`,
}